'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductCard } from '../product/product-card';

export const ProductsSwiper = ({ products }: { products: ProductDetailData[] }) => {
  return (
    <Swiper
      pagination={true}
      modules={[Pagination]}
      spaceBetween={16}
      slidesPerView={1.2}
      breakpoints={{
        1480: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2.85,
          spaceBetween: 24,
        },
        480: {
          slidesPerView: 1.85,
          spaceBetween: 20,
        },
      }}
      className={cn('custom-container', 'mySwiper', 'ea-blog-swiper__container', '!pb-10 md:pb-0')}
    >
      {products.map(product => (
        <SwiperSlide key={product.slug} className="w-full">
          <ProductCard product={product} key={product.slug} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
